import { Directive, ElementRef, Input, inject } from '@angular/core';
import { fromEvent } from 'rxjs';

@Directive({
  selector: '[appToggleBtn]'
})
export class ToggleBtnDirective {
  private element = inject(ElementRef);

  /** Inserted by Angular inject() migration for backwards compatibility */


  // used in form Element component
  constructor() { }

  ngOnInit(){
    fromEvent(this.element.nativeElement, 'click').subscribe(() => {
      //toogle on/off
      this.element.nativeElement.classList.toggle('on')
    });
  }

}
